<footer class="bg-footer-background px-8 py-20 text-footer-text md:px-16">
  <div class="flex flex-col">
    <!-- Main Content -->
    <div
      class="mb-10 flex flex-col items-start justify-start gap-10 md:mb-20 md:gap-20"
    >
      <!-- Title -->
      <h2
        class="self-stretch bg-gradient-to-r from-[#008b79] to-[#004365] bg-clip-text text-5xl leading-tight font-medium text-transparent md:text-7xl lg:text-9xl"
      >
        {{ 'components.footer.title' | translate }}
      </h2>

      <!-- Description and Links -->
      <div
        class="flex w-full flex-col justify-between gap-16 lg:flex-row lg:gap-8"
      >
        <!-- Description and LinkedIn -->
        <div class="flex w-full flex-col gap-8 lg:w-3/12">
          <!-- Footer description disabled per customer request -->
          <!-- <p class="text-base font-normal leading-tight text-secondary-text md:text-lg">
          {{ 'components.footer.description' | translate }}
        </p> -->
          <a
            class="font-ibmPlexMono text-base leading-normal font-normal text-white underline transition-colors hover:text-footer-link"
            href="https://nl.linkedin.com/company/uitgeverij-den-hollander"
            target="_blank"
          >
            {{ 'components.footer.linkedin' | translate }}
          </a>
        </div>

        <!-- Navigation Links -->
        <div class="flex flex-col gap-8 sm:flex-row md:gap-16">
          <!-- Navigation Sections -->
          @for (section of navigationSections; track section.title) {
            <div class="flex flex-col gap-2">
              <h3 class="text-base leading-normal font-medium text-neutral-50">
                {{ 'components.footer.' + section.title | translate }}
              </h3>
              <ul class="space-y-1">
                @for (item of section.items; track item.link) {
                  <li>
                    <a
                      class="text-base leading-normal font-normal text-secondary-text transition-colors hover:text-footer-link"
                      [routerLink]="item.link"
                    >
                      {{ 'components.footer.' + item.label | translate }}
                    </a>
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Footer Bottom -->
    <div class="flex flex-col gap-6 self-stretch">
      <div
        class="border-footer-border h-px self-stretch border-t opacity-20"
      ></div>
      <div class="flex flex-col gap-6 sm:flex-row-reverse sm:justify-between">
        <!-- Links -->
        <div
          class="flex flex-col space-y-2 text-left sm:flex-row sm:space-y-0 sm:space-x-6"
        >
          @for (item of bottomLinks; track item.link) {
            <a
              class="text-sm leading-tight font-normal text-secondary-text underline transition-colors hover:text-footer-link"
              [routerLink]="[item.link]"
            >
              {{ 'components.footer.' + item.label | translate }}
            </a>
          }
        </div>
        <!-- Copyright -->
        <p
          class="flex items-center gap-1 text-left text-sm leading-tight font-normal text-secondary-text"
        >
          <span>&copy;</span>
          {{ 'components.footer.copyright' | translate: { year: currentYear } }}
        </p>
      </div>
    </div>
  </div>
</footer>
